<ng-container *ngFor="let tag of tags">
  <span *ngIf="tag.kind === 'badge'" class="stock-badge product-tag-badge" [ngClass]="tag.class">{{ tag.text }}</span>
  <mat-icon *ngIf="tag.kind === 'icon'" class="product-tag-icon" [style.color]="tag.color" [title]="tag.tooltip">{{ tag.icon }}</mat-icon>
</ng-container>
